import React, { useState, useEffect } from 'react';
import {userInfoField} from '@/config/config';
import { UserOutlined,DownOutlined,MenuOutlined } from '@ant-design/icons';
import { Avatar, Space,Dropdown,Divider } from 'antd';
import {LogoutOutlined} from '@ant-design/icons'
import type { MenuProps } from 'antd';
import { Link } from 'react-router-dom';

const userInfo=JSON.parse(sessionStorage.getItem(userInfoField) as any);

const Component = (props: any) => {


  const logout=()=>{
    sessionStorage.removeItem(userInfoField);
    window.location.href='/'
  }

  const items: MenuProps['items'] = [
    // {
    //   key: 'userInfo',
    //   label: (
    //     <Link to='/user/info'>
    //       我的资料
    //     </Link>
    //   ),
    // },
    {
      key: 'logout',
      danger: true,
      label: <div onClick={logout} style={{padding:'5px 10px'}}><LogoutOutlined /> 退出</div>,
    },
  ];

  
  
return (
<div className='userPanel'>
<Dropdown menu={{ items }} arrow placement='bottom'>
<Space size={10}>
    <Avatar 
    size={40} 
    style={{ backgroundColor: '#024dc4' }} 
    icon={<UserOutlined />}
    // onClick={alert}
    />
    {/* <DownOutlined style={{color:'#fff',fontSize:'12px'}} /> */}
    {/* <MenuOutlined style={{color:'#000',fontSize:'23px'}} /> */}
</Space>
</Dropdown>


</div>
);
};

export default Component;